<template>
    <div class="chat-window">
        <div id="chat-list-panel" ref="leftPanel">
            <table class="w3-table w3-striped w3-bordered w3-border w3-hoverable w3-white">
                <thead>
                    <tr class="w3-green">
                        <th>AppId</th>
                        <th>Msg</th>
                        <th>Time</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in ALLUserLastChatList" :key="index" class="w3-padding"
                        @click="openChat(item.user)">
                        <td class="w3-text-grey">{{ UserName(item.user) }}</td>
                        <td class="w3-text-grey">{{ item.lastChat.c }}</td>
                        <td class="w3-text-grey">{{ $filters.formatDate(item.lastChat.tm) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div id="resizer" @mousedown="startDrag"></div>
        <div class="chat-panel" ref="rightPanel">
            <div class="chat-header">
                <div v-if="pcMode == false" id="chat-header-btn" @click="showChatList()">&lt;Back</div>
                <div>{{ to }}</div>
                <div>{{ msg }}</div>
            </div>
            <div id="output" style="border:1px solid #ccc;background-color: rgb(238, 234, 234);overflow: auto;"
                ref="chatHistory">
                <div v-for="(item, index) in SelectedUserChatList" :key="index">
                    <div v-if="item.f == this.nickName" class="newmsg">{{ item.f }} {{ this.formatDate(item.tm) }}</div>
                    <div v-if="item.f == this.nickName" class="newmsg bubbler">{{ item.c }}</div>
                    <div v-if="item.f != this.nickName" class="newreply">{{ item.f }} {{ this.formatDate(item.tm) }}
                    </div>
                    <div v-if="item.f != this.nickName" class="newreply bubblel">{{ item.c }}</div>
                </div>
            </div>
            <div class="w3-flex">
                <input type="text" class="w3-input w3-border" v-model="inputTxt" placeholder="待发信息" required
                    @keydown.enter="onEnter">
                <button type="button" :disabled="btnDisabled" class="w3-button w3-blue w3-block" style="width: 80px;"
                    @click="onEnter">发送</button>
            </div>
        </div>
    </div>

</template>

<script>

var websocket;
var connTimes = 0;
var connected = false;

export default {
    data() {
        return {
            iskick: false,
            userList: [],
            msg: 'dd',
            wlcMsg: '',
            currentChatName: '',
            to: '',
            inputTxt: '',
            nickName: '',
            userName: '',
            userPass: '',
            dragging: false,
            pcMode: false,
            btnDisabled: false
        };
    },
    computed: {
        ALLUserLastChatList() {
            let list = [];
            for (let i = 0; i < this.userList.length; i++) {
                let user = this.userList[i].user;
                let lastChat = this.userList[i].records[0];
                for (let j = this.userList[i].records.length - 1; j > 0; j--) {
                    if (this.userList[i].records[j].f == user) {
                        lastChat = this.userList[i].records[j];
                        break;
                    }
                }
                //console.log("user:",user);
                //console.log("lastChat",lastchat);
                list.push({ "user": user, "lastChat": lastChat });
            }
            return list;
        },
        SelectedUserChatList() {
            for (let i = 0; i < this.userList.length; i++) {
                if (this.userList[i].user == this.to) {
                    return this.userList[i].records;
                }
            }
            return [];
        }

    },
    mounted() {
        document.addEventListener("mouseup", () => (this.dragging = false));
        document.addEventListener("mousemove", e => {
            if (!this.dragging) return;
            const w = e.clientX;
            if (w > 200 && w < 500) {
                this.$refs.leftPanel.style.width = w + "px";
            }
        });

        const leftPanel = this.$refs.leftPanel;
        const rightPanel = this.$refs.rightPanel;
        if (window.innerWidth < 768) {
            this.pcMode = false;
            leftPanel.style.width = '100%';
            rightPanel.style.display = 'none';
        } else {
            this.pcMode = true;

        }
        console.log('this.pcMode=' + this.pcMode);
        

    },
    created() {
        const query = this.$route.query;

        if (query.u && query.p) {
            sessionStorage.setItem('userName', query.u);
            sessionStorage.setItem('userPass', query.p);
        }
        this.userName = sessionStorage.getItem('userName');
        this.userPass = sessionStorage.getItem('userPass');
        if (this.userName && this.userPass) {
            this.login();
            setInterval(() => {
                this.KeepAlive();
            }, 10000);
        } else {
            this.$router.push('/login');
        }
    },
    methods: {
        UserName(name) {
            if (name.length > 10) {
                return name.substr(0, 10) + "...";
            }
            return name;
        },
        showChatList() {
            if(this.pcMode == false){
                const leftPanel = this.$refs.leftPanel;
                leftPanel.style.display = 'flex';
                leftPanel.style.width = '100%';
                
                const rightPanel = this.$refs.rightPanel;
                rightPanel.style.display = 'none';
            }
        },
        startDrag() {
            this.dragging = true;
        },
        openChat(user) {
            if (this.pcMode == false) {
                const leftPanel = this.$refs.leftPanel;
                const rightPanel = this.$refs.rightPanel;
                leftPanel.style.display = 'none';
                rightPanel.style.display = 'flex';
            }

            this.to = user;
            const msg = `{"id":"userChatList","body":{"user":"${user}"}}`;
            // console.log(msg);
            this.sendMsg(msg);
        },
        KeepAlive() {
            if (connected) {
                const msg = `{"id":"keepAlive"}`;
                this.sendMsg(msg);
            }
        },
        onEnter() {
            this.doSend();
        },
        async login() {
            this.startWebSocket(this.$wssAddr);
        },
        formatDate(value, format = 'YYYY/MM/DD HH:mm:ss') {

            if (!value) return ''

            const date = new Date(value)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')

            let df;
            const now = new Date();

            if (now.getDate() === date.getDate()) {
                df = format.replace('YYYY/MM/DD', '今天');
            } else if (now.getDate() - 1 === date.getDate()) {
                df = format.replace('YYYY/MM/DD', '昨天');
            } else if (now.getDate() < date.getDate() + 7) {
                const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
                const weekDay = weekDays[date.getDay()];
                df = format.replace('YYYY/MM/DD', weekDay);
            } else {
                df = format;
            }
            return df
                .replace('YYYY', year)
                .replace('MM', month)
                .replace('DD', day)
                .replace('HH', hours)
                .replace('mm', minutes)
                .replace('ss', seconds);

        },
        startWebSocket(wsUri) {
            try {
                websocket = new WebSocket(wsUri);
                websocket.onopen = this.onOpen;
                websocket.onclose = this.onClose;
                websocket.onmessage = this.onMessage;
                websocket.onerror = this.onError;
            } catch (error) {
                this.onMsg(error);
            }

        }, onOpen() {
            connected = true;
            connTimes = 0;
            const msg = `{"id":"login","body":{"appId":"${this.userName}","token":"${this.userPass}","admin":"1"}}`;
            this.sendMsg(msg);

        }, onClose() {
            connected = false;
            if (this.iskick == true) {
                return;
            }
            this.onMsg("<span style='color:red'>连接已断开!</span>");
            if (connTimes < 3) {
                websocket.close();
                this.onMsg("<span style='color:red'>正在重连!</span>");
                connTimes++;
                this.startWebSocket(this.$wssAddr);
            } else {
                this.onMsg("<span style='color:red'>重连多次失败，请稍后再试!</span>");
            }
        }, onMessage(evt) {
            connected = true;
            const msgObj = JSON.parse(evt.data);
            // console.log('Received message: ', evt.data);
            if (msgObj != null) {
                const id = msgObj.id;
                const body = msgObj.body;


                if (id == "loginS") {
                    this.nickName = body.nickName;
                    this.to = body.to;
                    this.wlcMsg = body.msg;
                    this.KeepAlive();

                } if (id == "loginF") {
                    let c = body.reason;
                    this.onMsg(c);
                    connected = false;
                    this.iskick = true;
                    this.btnDisabled = true;
                } else if (id == "userList") {
                    this.msg = '';
                    this.userList = [];
                    const list = body;
                    for (let i in list) {
                        let records = [];
                        records.push(list[i]);
                        this.userList.push({ "user": list[i].f, "records": records });
                    }
                    // console.log(this.userList);


                } else if (id == "userChatList") {
                    this.msg = '';
                    // this.clearMsg();
                    const user = body.user;
                    const records = body.records;

                    for (let i = 0; i < this.userList.length; i++) {
                        if (this.userList[i].user == user) {
                            this.userList[i].records = records;
                            break;
                        }
                    }
                    // console.log(this.userList);

                    this.$nextTick(() => this.scrollToBottom());
                } else if (id == "msg") {
                    this.msg = '';
                    let user = body.f == "客服" ? body.t : body.f;

                    for (let i = 0; i < this.userList.length; i++) {
                        if (this.userList[i].user == user) {
                            let item = this.userList[i];
                            item.records.push(body);
                            this.userList.splice(i, 1);
                            this.userList.unshift(item);
                            break;
                        }
                    }
                    this.$nextTick(() => this.scrollToBottom());
                } else if (id == "kick") {
                    let c = body.c;
                    this.onMsg(c);

                    connected = false;
                    this.btnDisabled = true;
                }

            }
        }, onMsg(c) {
            this.msg = c;
        },
        onError() {
            connected = false;
            //this.appendToChatWin('<span style="color: red;">发生错误</span> ');
        }, sendMsg(msg) {

            if (typeof websocket === "undefined") {
                alert("还没有连接，或者连接失败，请检测");
                return false;
            }
            if (websocket.readyState == 3) {
                alert("连接已经关闭，请刷新页面");
                return false;
            }
            websocket.send(msg);

        }, doSend() {
            var text = this.inputTxt;
            if (text.trim() == '') {
                alert("请先填写发送信息");
                return false;
            }
            if (text.length > 500) {
                alert("请缩短发送内容再试");
                return false;
            }
            this.inputTxt = '';

            const msg = `{"id":"msg","body":{"to":"${this.to}","msg":"${text}"}}`;

            this.sendMsg(msg);
        },
        scrollToBottom() {
            const el = this.$refs.chatHistory;
            if (el) el.scrollTop = el.scrollHeight;
        }
    }
};

</script>


<style>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: "Microsoft YaHei", Arial, sans-serif;
}

.chat-window {
    display: flex;
    width: 100%;
    height: calc(100vh - 40px);

}

#chat-list-panel {
    width: 300px;
    min-width: 250px;
    flex-direction: column;
    transition: width 0.1s;
}

.chat-panel {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
}

.w3-table {
    width: 100%;
}

.chat-header {
    height: 50px;
    padding: 0 15px;
}

#resizer {
    width: 5px;
    cursor: col-resize;
    background: transparent;
}

#output {
    height: calc(100vh - 60px);
    font-family: Avenir, Helvetica, Arial, sans-serif;
    text-align: center;
    color: #2c3e50;

    @media (max-width: 767px) {
        font-size: small;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        font-size: medium;
    }

    @media (min-width: 1025px) {
        font-size: medium;
    }
}


/* 固定底部导航 */
.bottom-btn {
    position: fixed;
    bottom: 38px;
    left: 0;
    right: 0;
    z-index: 1000;
    /* 确保导航在最顶层 */
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    /* 顶部阴影效果 */
}

.newmsg {
    width: 100%;
    color: blue;
    text-align: right;
}

.bubbler {
    background-color: #90ee90;
    color: black;
    width: fit-content;
    max-width: 60%;
    word-wrap: break-word;
    text-align: left;
    margin-left: auto;
    margin-right: 15px;
    padding: 10px;
    border-radius: 9px;
    overflow: visible;
}

.newreply {
    width: 100%;
    color: green;
    text-align: left;
}

.bubblel {
    background-color: white;
    color: black;
    width: fit-content;
    max-width: 60%;
    word-wrap: break-word;
    padding: 10px;
    margin-left: 15px;
    margin-right: auto;
    border-radius: 9px;
    overflow: visible;
}


</style>
